import type { ReactElement } from 'react';
import type { AuthStatusResponse } from '@shared/api';

/**
 * The app chrome's brand mark: the signed-in rep's agency cobrand (logo when
 * one is configured, `appName` text otherwise), resolved server-side from
 * GET /api/auth/status -> branding.
 *
 * Distinct from components/BrandMark.tsx, which renders a PROPOSAL's theme
 * brand inside the document canvas (client-facing, unrelated concern) — this
 * one is the app's own topbar/start-page mark.
 *
 * `branding` is undefined until auth status has loaded and null on a failed
 * status fetch; both render nothing so the app chrome never flashes the
 * default VisitIQ mark before the rep's real cobrand is known.
 */
export function AppBrand({
  branding,
}: {
  branding: AuthStatusResponse['branding'] | null | undefined;
}): ReactElement | null {
  if (!branding) return null;
  if (branding.logoUrl) {
    return (
      <img
        key={branding.logoUrl}
        className={`app-brand app-brand-logo${
          branding.cobrand === 'visitiq' ? ' app-brand-logo-default' : ''
        }`}
        src={branding.logoUrl}
        alt={branding.appName}
      />
    );
  }
  return <span className="app-brand app-brand-text">{branding.appName}</span>;
}
